import { useEffect, useState } from "react"
import type { DraftNode } from "@/entities/bot-builder"
import type { DraftActions } from "@/features/edit-scenario-draft"
import { Button } from "@/shared/ui/button"
import { RichTextEditor } from "@/shared/ui/rich-text-editor"

export const WELCOME_NOTE = "Приветствие Botmaker"

export function WelcomeMessage({ node, actions }: { node: DraftNode; actions: DraftActions }) {
	const saved = String(node.config.text ?? "")
	const [text, setText] = useState(saved)
	useEffect(() => setText(saved), [saved])
	return (
		<div className="space-y-2">
			<RichTextEditor
				format="telegram-html"
				ariaLabel="Текст приветствия"
				minHeight="8.5rem"
				placeholder="Привет, ${firstName}! Вот что умеет этот бот…"
				value={text}
				onChange={setText}
			/>
			<div className="flex justify-end">
				<Button
					size="sm"
					variant="outline"
					disabled={text === saved}
					onClick={() => void actions.updateNode(node.id, { config: { ...node.config, text } })}
				>
					Сохранить
				</Button>
			</div>
		</div>
	)
}
